/**
 * Determine if element overflows parent
 * @param {HTMLElement} container Parent element
 * @param {HTMLElement} content Scrolling element
 * @returns {{left:boolean, right:boolean}}
 */
export default function(container, content) {
  const containerWidth = container.offsetWidth
  const contentWidth = content.scrollWidth
  const scrollLeft = container.scrollLeft

  return {
    left: !!scrollLeft,
    right: contentWidth > containerWidth + scrollLeft
  }
}
